module.exports = __webpack_public_path__ + "assets/travel_white.4ae7a298.svg";